export default "__VITE_ASSET__D9J6zNG___"